var _rect, _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarWithHoodUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.162,
    height: 134.803,
    viewBox: "0 0 207.162 134.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589.969 -211.283)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.484,
    height: 36.013,
    transform: "matrix(1, 0.001, -0.001, 1, 771.609, 262.447)",
    fill: "#26242d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M788.1,325.51l-4.1,5.783a8.629,8.629,0,0,1-6.975,3.639L614,334.014l-12.787-.076a8.541,8.541,0,0,1-6.989-4.155l-2.154-3.042L620.7,304.889l97.876-5.173L780.19,308.9Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.069,326.741a20.94,20.94,0,0,1-1.834-4.963,20.5,20.5,0,0,1-.266-3.792,7.351,7.351,0,0,1,3.27-6.088h0s-1.148-12.124.885-16.512c0,0-.209-.521-.469-1.323a9.751,9.751,0,0,1,2-9.477l5.293-5.95c9.133-10.267,12.019-14.928,25.62-16.89,20.569-2.968,60.58-6.166,78.94,1.718,16.443,7.06,25.2,11.435,31.578,15.148,3.241,1.887,9.317,5.687,12.822,6.99,2.892,1.075,6.465,2.969,9.371,4.035,7.558,2.774,8.161,3.866,14.928,6.7,2.244.939,6.014,1.851,7.864,3.379,3.857,3.184,9.281,4.979,9.089,9.977l-.434,13.526a4.9,4.9,0,0,1-4.826,4.722Z",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.036,287.4c-2.908-1.177-6.672-2.174-9.531-1.1a4.383,4.383,0,0,0-2.732,4.589c.006.055.013.111.02.168a4.269,4.269,0,0,0,4.333,3.644l6.965-.134a3.309,3.309,0,0,0,2.533-1.257h0A3.821,3.821,0,0,0,609.036,287.4Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.212,302.936c-1.239-2.354-4.472-6.038-12.858-8.183a1.425,1.425,0,0,0-1.427,2.321l1.22,1.379a22.7,22.7,0,0,0,7.071,5.388,19.15,19.15,0,0,0,4.159,1.551A1.7,1.7,0,0,0,785.212,302.936Z",
    fill: "#f7fefb",
    stroke: "#f7fefb",
    strokeMiterlimit: 10,
    strokeWidth: 0.937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.728,267.36c5.5-1.8,28.476-2.274,28.476-2.274a4.869,4.869,0,0,1,5.2,4.083l2.265,14.238a4.862,4.862,0,0,1-4.83,5.625l-21.856-.127c-5.261-.031-10.275-4.4-13.206-8.774-.068-.1-.136-.205-.2-.309C618.836,275.563,620.915,268.935,625.728,267.36Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.193,263.941a107.8,107.8,0,0,1,60.323,20.1,3.089,3.089,0,0,1-1.83,5.6l-56-.524a5.125,5.125,0,0,1-5-4.252L667.1,269.938A5.119,5.119,0,0,1,672.193,263.941Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.927,284.395c.229-2.417-7.621-8.787-13.569-6.309-2.339,1.222-3.017,6.644,3.01,7.876C718.659,287.044,723.7,286.812,723.927,284.395Z",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.017,297.235l-11.279-.067a1.693,1.693,0,0,1-1.679-1.7h0a1.693,1.693,0,0,1,1.7-1.679l11.279.067a1.693,1.693,0,0,1,1.679,1.7h0A1.693,1.693,0,0,1,696.017,297.235Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.731,296.984l-11.279-.066a1.7,1.7,0,0,1-1.68-1.7h0a1.7,1.7,0,0,1,1.7-1.679l11.279.067a1.694,1.694,0,0,1,1.679,1.7h0A1.693,1.693,0,0,1,653.731,296.984Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.909,327.894c0-.163.007-.325,0-.489-.17-11.539-9.312-20.728-20.419-20.524-10.95.2-19.715,9.457-19.8,20.774Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.218,328.6c0-.163.007-.325,0-.488-.17-11.54-9.312-20.729-20.419-20.525-10.95.2-19.715,9.457-19.8,20.775Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.053,
    cy: 16.347,
    rx: 17.053,
    ry: 16.347,
    transform: "translate(610.966 310.688) rotate(-0.945)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.057,327.353a10.237,10.237,0,1,0,10.065-9.972A10.023,10.023,0,0,0,618.057,327.353Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.274,327.267a5.015,5.015,0,1,0,4.93-4.885A4.911,4.911,0,0,0,623.274,327.267Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.053,
    cy: 16.347,
    rx: 17.053,
    ry: 16.347,
    transform: "translate(730.799 311.399) rotate(-0.945)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.89,328.063a10.237,10.237,0,1,0,10.064-9.972A10.022,10.022,0,0,0,737.89,328.063Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.107,327.977a5.014,5.014,0,1,0,4.93-4.884A4.909,4.909,0,0,0,743.107,327.977Z",
    fill: "#26242d"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M785.753,346.086H594.421a2.352,2.352,0,0,1-2.352-2.352h0a2.352,2.352,0,0,1,2.352-2.352H785.753a2.352,2.352,0,0,1,2.352,2.352h0A2.352,2.352,0,0,1,785.753,346.086Z",
    fill: "#ebedf2",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M748.113,285.606s13.1-20.846,29.633-28.7c1.888-.9,3.386.865,2.014,2.378l-26.507,29.23Z",
    fill: "#15b9e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M774.928,213.3a2.013,2.013,0,1,1-2.013-2.013A2.013,2.013,0,0,1,774.928,213.3Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M786.03,213.3a2.014,2.014,0,1,1-2.013-2.013A2.013,2.013,0,0,1,786.03,213.3Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M797.131,213.3a2.013,2.013,0,1,1-2.013-2.013A2.013,2.013,0,0,1,797.131,213.3Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithHoodUp);
export default __webpack_public_path__ + "static/media/car-with-hood-up.45bf0b2213eaf473127598cf94d57421.svg";
export { ForwardRef as ReactComponent };